

interface OverviewState {
    isLoading: boolean;
    error: string | null;
}



const initialState: OverviewState = {

    isLoading: false,
    error: null
};

const OverviewReducer = (state = initialState, action: { type: string; payload?: any }): OverviewState => {
    switch (action.type) {
        default:
            return state;
    }
};

export default OverviewReducer;